import { mergeStyleSets } from '@fluentui/react';

export const useStyles = () => {
  return mergeStyleSets({
    propertyRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  });
};
